import { component } from 'picoapp';

export default component(async (node) => {
  const suggestionProducts:NodeListOf<HTMLElement> = node.querySelectorAll('[data-variant]');

  suggestionProducts.forEach((product) => {
    const submit = product.querySelector('[data-submit]');
    submit.addEventListener('click', () => {
      const data = JSON.parse(product.dataset.variant);
      const item = {
        id: data.id,
        quantity: 1,
        compare_at_price: data.compare_at_price,
        tags: data.tags,
      };
      document.dispatchEvent(new CustomEvent('cart:add:variant', { detail: { items: [item] } }));
    });
  });
});
